import api from "./api";

// Capa de servicios API del dominio "onboarding" (config de negocio / agenda:
// perfiles, secuencias, servicios, profesionales) (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).

// --- Config / activación ---
export const getOnboardingConfig = () => api.get("/onboarding/config");
export const completeOnboarding = (payload) =>
  api.post("/onboarding/complete", payload);
export const activateOnboarding = (payload) =>
  api.post("/onboarding/activate", payload);

// --- Secuencias ---
export const listOnboardingSequences = () => api.get("/onboarding/sequences");
export const createOnboardingSequence = (payload) =>
  api.post("/onboarding/sequences", payload);
export const updateOnboardingSequence = (id, payload) =>
  api.put(`/onboarding/sequences/${id}`, payload);
export const deleteOnboardingSequence = (id) =>
  api.delete(`/onboarding/sequences/${id}`);

// --- Servicios ---
export const createOnboardingService = (payload) =>
  api.post("/onboarding/services", payload);
export const updateOnboardingService = (id, payload) =>
  api.put(`/onboarding/services/${id}`, payload);
export const deleteOnboardingService = (id) =>
  api.delete(`/onboarding/services/${id}`);

// --- Profesionales ---
export const createOnboardingProfessional = (payload) =>
  api.post("/onboarding/professionals", payload);
export const updateOnboardingProfessional = (id, payload) =>
  api.put(`/onboarding/professionals/${id}`, payload);
export const deleteOnboardingProfessional = (id) =>
  api.delete(`/onboarding/professionals/${id}`);

// Residuales agenda/config (useAppointmentsConfig, layout) usando PATCH.
export const updateOnboardingBusinessHours = (payload) =>
  api.patch("/onboarding/business-hours", payload);
export const updateOnboardingSequenceByKey = (sequenceKey, payload) =>
  api.patch(`/onboarding/sequences/${sequenceKey}`, payload);
export const updateOnboardingProfessionalUser = (professionalId, payload) =>
  api.patch(`/onboarding/professionals/${professionalId}`, payload);
export const patchOnboardingConfig = (payload) =>
  api.patch("/onboarding/config", payload);
